import variables from 'common-ui-components/src/vtj/theme/variables'

const tabletMaxWidth = 992
const mobileMaxWidth = 495
const tabletMinWidth = mobileMaxWidth + 1
const desktopMinWidth = tabletMaxWidth + 1
export default {
  tabletMaxWidth: tabletMaxWidth,
  mobileMaxWidth: mobileMaxWidth,
  tabletMinWidth: tabletMinWidth,
  desktopMinWidth: desktopMinWidth,
  mobile: `@media(max-width: ${mobileMaxWidth}px)`,
  tablet: `@media(min-width: ${tabletMinWidth}px) and (max-width: ${tabletMaxWidth}px)`,
  mobileAndTablet: `@media(max-width: ${tabletMaxWidth}px)`,
  tabletAndDesktop: `@media(min-width: ${tabletMinWidth}px)`,
  desktop: `@media(min-width: ${desktopMinWidth}px)`,
  ie: `@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)`,
  desktopMaxContent: `@media(min-width: ${variables.desktopMaxWidthBreakPoint}px)`,
  tabletMaxContent: `@media(min-width: ${variables.tabletMaxWidthBreakpoint}px)`,
  mobileContent: `@media(max-width: ${
    variables.contentMaxWidth + 2 * variables.padding
  }px)`,
  betweenMobileAndContentMax: `@media (max-width: ${variables.contentMaxWidth}px) and (min-width: ${tabletMinWidth}px)`,
  betweenTabletAndTabletContentMax: `@media (max-width: ${
    variables.tabletMaxWidthBreakpoint - 1
  }px) and (min-width: ${desktopMinWidth}px)`,
}
